export default __webpack_public_path__ + "static/media/avatar2.0ea8ffa5.png";